"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Legend_1 = require("./Legend");
exports.Legend = Legend_1.default;
var legendOptions_1 = require("./legendOptions");
exports.legendOptions = legendOptions_1.default;
//# sourceMappingURL=index.js.map